import { PermissionEnum } from '~/modules/shared/composables/utils/Enums';
import { useUserStore } from '~/modules/shared/composables/stores/UserStore';

export default defineNuxtPlugin(() => {
  addRouteMiddleware('can-manage', () => {
    const userStore = useUserStore();
    if (
      userStore.currentUser?.tsammPermission.includes(PermissionEnum.CanManage) ||
      userStore.currentUser?.tsammPermission.includes(PermissionEnum.GodPermission)
    ) {
      return true;
    }
    window.location.href = '/';
  });
});
